var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rb-eyewear-protection-overlay-content" }, [
    _c("div", { staticClass: "rb-overlay-header" }, [
      _c("div", { staticClass: "--title" }, [
        _vm._v(_vm._s(_vm.$t("eyewear_protection.overlay.header.title"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "--subtitle" }, [
        _vm._v(_vm._s(_vm.headerSubtitle)),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "common__icon common__icon--asurion --icon" }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rb-infographic-boxes" },
      [
        _c("rb-infographic-box", {
          staticClass: "--infographic-box",
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("span", {
                    staticClass: "common__icon common__icon--tools",
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "--infographic-box-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "eyewear_protection.overlay.content.infographics.first.title"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "excerpt_block",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "--infographic-box-excerpt_block" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "eyewear_protection.overlay.content.infographics.first.excerpts.first"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "--infographic-box-excerpt_block" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.standardLabel) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "--infographic-box-excerpt_block" },
                    [
                      _c("p", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "eyewear_protection.overlay.content.infographics.first.excerpts.third.claim"
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "eyewear_protection.overlay.content.infographics.first.excerpts.third.chat"
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "eyewear_protection.overlay.content.infographics.first.excerpts.third.hours"
                              )
                            ) +
                            "\n          "
                        ),
                      ]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
        _vm._v(" "),
        _c("rb-infographic-box", {
          staticClass: "--infographic-box",
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("span", {
                    staticClass: "common__icon common__icon--broken-lens",
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "--infographic-box-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "eyewear_protection.overlay.content.infographics.second.title"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "excerpt_block",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "--infographic-box-excerpt_block" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "eyewear_protection.overlay.content.infographics.second.excerpts.first"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "--infographic-box-excerpt_block" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "eyewear_protection.overlay.content.infographics.second.excerpts.second"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "--infographic-box-excerpt_block" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "eyewear_protection.overlay.content.infographics.second.excerpts.third"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "--infographic-box-excerpt_block" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "eyewear_protection.overlay.content.infographics.second.excerpts.fourth"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "--infographic-box-excerpt_block --terms-and-conditions",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t(
                          "eyewear_protection.overlay.content.infographics.second.excerpts.fifth"
                        )
                      ),
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }),
        _vm._v(" "),
        _c("rb-infographic-box", {
          staticClass: "--infographic-box",
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("span", {
                    staticClass:
                      "common__icon common__icon--pay-with-flexbility",
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "--infographic-box-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "eyewear_protection.overlay.content.infographics.third.title"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "excerpt_block",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "--infographic-box-excerpt_block" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "eyewear_protection.overlay.content.infographics.third.excerpts.first"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "--infographic-box-excerpt_block" },
                    [
                      _vm._v(
                        "\n          " + _vm._s(_vm.copayLabel) + "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "--infographic-box-excerpt_block" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.copayRoxLabel) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
        _vm._v(" "),
        _c("rb-infographic-box", {
          staticClass: "--infographic-box",
          scopedSlots: _vm._u([
            {
              key: "icon",
              fn: function () {
                return [
                  _c("span", {
                    staticClass: "common__icon common__icon--list",
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "title",
              fn: function () {
                return [
                  _c("div", { staticClass: "--infographic-box-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t(
                            "eyewear_protection.overlay.content.infographics.fourth.title"
                          )
                        ) +
                        "\n        "
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "excerpt_block",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "--infographic-box-excerpt_block" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "eyewear_protection.overlay.content.infographics.fourth.excerpts.first"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "--infographic-box-excerpt_block" },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "eyewear_protection.overlay.content.infographics.fourth.excerpts.second"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "rb-overlay-footer" }, [
      _c("div", { staticClass: "rb-overlay-footer__title" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("eyewear_protection.overlay.footer.title")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "rb-overlay-footer__subtitle" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("eyewear_protection.overlay.footer.subtitle.first")) +
            "\n    "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "rb-overlay-footer__subtitle" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.$t("eyewear_protection.overlay.footer.subtitle.second")
            ) +
            "\n    "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }